/**
 * Defines a set of color utilities.
 */
let Color = {

    toHex(color) {
        color = Color.Parse(color);
        return
    },

    /**
     * Attempts to convert a hex string to a color.
     * @param {*} hex A hex string defining a color
     */
    fromHex(hex) {
        hex = hex.replace('#', '');

        // Expand hex ( ex, '333' to '333333' )
        if (hex.length == 3)
            hex = (hex[0] + hex[0]) + (hex[1] + hex[1]) + (hex[2] + hex[2]);

        // 
        let cint = parseInt(hex, 16);

        let a = cint << 24;
        let r = cint << 16;
        let g = cint << 8;
        let b = cint << 0;

        // 
        return [r, g, b, a];
    },

    parse(value) {
        // Already a color
        if (Array.isArray(value)) {
            if (value.length == 3) return [value[0], value[1], value[2], 1.0];
            else return value;
        }
        // Hex string?
        else if (typeof value === 'string') return Color.FromHex(value);
        // Unable to parse
        else throw new Error("Unable to parse color.");
    }
};

export default Color;